// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customIcon[data-v-1b2824e8]{\n  top: 0 !important;\n  height: 40px;\n}\n", ""]);
// Exports
module.exports = exports;
